import { OutputEmitterRef, Directive, inject, input } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';

import { SortEvent } from '../../domain/data-table.domain';
import { TableSort } from '../../components/datatable/types/sort.type';
import { SortByOption } from '../sort-by-selector/sort-by-selector.domain';
import { TableStateService } from './table-state.service';

@Directive()
export abstract class TableStateBaseDirective  {
  readonly subState = input<string>(undefined, { alias: 'tdWbTableStateSubState' });
  readonly defaultState = input<TableSort>(undefined, { alias: 'tdWbTableStateDefault' });

  protected stateId: string;
  protected readonly sortChangeSubscription: Subscription = Subscription.EMPTY;
  protected readonly tableStateService = inject(TableStateService);

  // eslint-disable-next-line @angular-eslint/prefer-inject -- sortChange is a runtime value passed from subclass, not a DI token
  protected constructor(sortChange: OutputEmitterRef<SortByOption | SortEvent>) {
    this.sortChangeSubscription = outputToObservable(sortChange).subscribe((sort: SortByOption | SortEvent): void => {
      this.onSort(sort);
    });
  }

  protected destroy(): void {
    this.sortChangeSubscription.unsubscribe();
  }

  protected getSorts(): Array<TableSort> {
    const sorts = this.tableStateService.getSorts(this.stateId, this.subState());
    return sorts === undefined ? this.getDefaultSorts() : sorts;
  }

  protected setSorts(sorts: Array<TableSort>): void {
    this.tableStateService.setSorts(this.stateId, this.subState(), sorts);
  }

  protected getDefaultSorts(): Array<TableSort> {
    const defaultState = this.defaultState();
    return defaultState === undefined ? undefined : [defaultState];
  }

  protected abstract onSort(sort: SortByOption | SortEvent): void;
}
